// Main Product Page Scripts

// Total Price Calculation
(function() {
  function parsePrice(text) {
    if (!text) return 0;
    var num = text.replace(/[^0-9.]/g, '');
    return Number(num) || 0;
  }

  function getUnitPrice() {
    var form = document.querySelector('product-form[data-main-price]');
    if (form) {
      var raw = Number(form.getAttribute('data-main-price'));
      if (raw > 0) return raw / 100;
    }
    var el = document.querySelector('.product__price .price-item.price-item--sale');
    if (!el || !el.textContent.trim()) {
      el = document.querySelector('.product__price .price-item.price-item--regular');
    }
    return el ? parsePrice(el.textContent) : 0;
  }

  var addons = document.querySelectorAll('.addons .grid__item');

  if (addons.length > 0) {
    addons.forEach(function (addon) {
      var checkbox = addon.querySelector('input[type="checkbox"]');
      if (checkbox) {
        checkbox.addEventListener('change', function () {
          if (window.TotalPrice) window.TotalPrice();
        });
      }
    });
  }

  var quantityInput = document.querySelector('[name="quantity"]');
  if (quantityInput) {
    quantityInput.addEventListener('change', function () {
      try { if (window.TotalPrice) window.TotalPrice(); } catch(e) { console.error('TotalPrice error:', e); }
    });
  }

  window.TotalPrice = function () {
    var qtyEl = document.querySelector('[name="quantity"]');
    if (!qtyEl) return 0;
    var quantity = Number(qtyEl.value) || 1;

    var unitPrice = getUnitPrice();
    var total = quantity * unitPrice;

    addons = document.querySelectorAll('.addons .grid__item');
    if (addons.length > 0) {
      addons.forEach(function (addon) {
        var checkbox = addon.querySelector('input[type="checkbox"]');
        if (checkbox && checkbox.checked) {
          var priceEl = addon.querySelector('.price-item.price-item--regular');
          if (priceEl) {
            total += quantity * parsePrice(priceEl.textContent);
          }
        }
      });
    }

    var display = document.querySelector('.product__info-container .product-form__submit product-price');
    if (display) {
      display.innerHTML = '<span class="rupee-symbol">\u20B9</span>' + total.toLocaleString('en-IN');
    }

    return total;
  };
})();

// Thumbnail Slider Center List
(function() {
  const addCenter = document.querySelectorAll('.thumbnail-list li');
  if (addCenter.length === 0) {
    const sliderButtons = document.querySelector('.slider-buttons');
    if (sliderButtons) {
      sliderButtons.classList.add('button_hide');
    }
  }
  if (addCenter.length > 14) {
    const thumbnailList = document.querySelector('.thumbnail-slider .thumbnail-list.slider');
    if (thumbnailList) {
      thumbnailList.classList.add('center_list');
    }
  }
})();



